// Add-on fixed IDs
export const webshopAddOn = 1;
export const giftcardAddOn = 2;
export const accountingAddOn = 3;

// Add-on subscription plans fixed IDs
export const webshopBasicPlan = 2;
export const webshopProPlan = 1;

export default {
  webshopAddOn,
  giftcardAddOn,
  accountingAddOn,
  webshopBasicPlan,
  webshopProPlan,
};
